export const CHART_COLORS = {
    primary: '#8884d8',
    secondary: '#82ca9d',
    tertiary: '#ffc658',
    background: '#2d2d2d',
    text: '#ffffff',
    grid: '#444444',
    win: '#82ca9d',
    loss: '#ff8042'
};

export const THEME = {
    colors: {
        ...CHART_COLORS,
    },
    fontSize: {
        title: 16,
        axis: 12,
        tooltip: 14
    }
};
